module.exports = __webpack_public_path__ + "static/fonts/aeonik-regular.57bdff38.woff";